<template>
  <div id="OutStockBox" class="out-stock-box-page purchase-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>箱子管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="getData">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addBox">新增箱子</el-button>
          </div>
          <span class="toolbar-tip">共 {{ dataList.length }} 条</span>
        </div>
      </div>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="dataList" border stripe size="small" :height="screenHeight" :highlight-current-row="true" class="mgmt-table out-stock-box-table" header-cell-class-name="table-header-cell" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
          <el-table-column label="序号" type="index" width="56" align="center" fixed="left"></el-table-column>
          <el-table-column prop="status" label="状态" width="72" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" disabled></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="boxId" label="箱子编号" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="长*宽*高（cm）" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.length + "*" + scope.row.width + "*" + scope.row.height }}
            </template>
          </el-table-column>
          <el-table-column label="长*宽*高（英寸）" width="140" align="center">
            <template slot-scope="scope">
              {{ formatSizeInch(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="volume" label="体积" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="bubbleRatio" label="泡比" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="bubbleWeight" label="泡重" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="chargeableWeight" label="收费重量" width="88" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="localInventory" label="库存数量" width="88" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="inPurchase" label="采购中" width="80" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="inventory" label="已封箱数量" width="96" align="right" sortable class-name="amount-col"></el-table-column>
          <el-table-column prop="remark" label="备注" width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="材料组合" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="material-config-cell">{{ getMaterialConfigText(scope.row.materialConfig) || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="188" align="center" class-name="action-col">
            <template slot-scope="scope">
              <div class="action-cell">
                <el-button type="text" size="small" class="action-btn" @click="editBox(scope.row)">编辑</el-button>
                <el-button type="text" size="small" class="action-btn" @click="configMaterial(scope.row)">配置材料组合</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="addBoxDialogVisible" :close-on-click-modal="false" width="440px" custom-class="out-stock-box-dialog">
      <div class="form-line">
        <span class="form-label"><span>*</span>长（cm）</span>
        <el-input class="form-input" placeholder="请输入厘米" v-model="boxInfo.length" size="small" clearable></el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>宽（cm）</span>
        <el-input class="form-input" placeholder="请输入厘米" v-model="boxInfo.width" size="small" clearable></el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>高（cm）</span>
        <el-input class="form-input" placeholder="请输入厘米" v-model="boxInfo.height" size="small" clearable></el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>已封箱数量</span>
        <el-input class="form-input" placeholder="请输入" v-model="boxInfo.inventory" size="small" type="number" clearable></el-input>
      </div>
      <div class="form-line">
        <span class="form-label">备注</span>
        <el-input class="form-input" placeholder="请输入" v-model="boxInfo.remark" size="small" clearable></el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>状态</span>
        <el-switch v-model="boxInfo.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addBoxDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="handleConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog width="640px" title="配置材料组合" :visible.sync="configMaterialDialogVisible" :close-on-click-modal="false" append-to-body custom-class="out-stock-box-material-dialog">
      <div v-for="(config, index) in materialConfig" :key="index" class="form-line">
        <span class="form-label"><span>*</span>材料{{ index + 1 }}</span>
        <el-select class="form-select" placeholder="请选择" size="small" v-model="config.materialColor" filterable>
          <el-option v-for="(item, optionIndex) in materialColorLists" :key="optionIndex + '-' + item.materialColor" :label="item.materialName" :value="item.materialColor"></el-option>
        </el-select>
        <span class="count-label">数量</span>
        <el-input class="count-input" placeholder="请输入" v-model.number="config.count" size="small" type="number" clearable></el-input>
        <span>个</span>
        <el-button type="text" @click="deleteMaterial(index)">- 删除</el-button>
      </div>
      <div class="form-line">
        <el-button type="text" @click="addOneMaterial">+ 新增材料</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="configMaterialDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="materialSaving" @click="handleConfigMaterialConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors } from "../../utils/constant.js";

export default {
  data() {
    return {
      dataList: [],
      loading: false,
      saving: false,
      boxInfo: {
        width: "",
        height: "",
        length: "",
        inventory: 0,
        remark: "",
        status: 1,
      },
      screenHeight: 400,
      addBoxDialogVisible: false,
      configMaterialDialogVisible: false,
      materialSaving: false,
      materialBox: null,
      materialConfig: [],
      materials: [],
      colors: colors,
    };
  },
  computed: {
    dialogTitle() {
      return this.boxInfo && (this.boxInfo._id || this.boxInfo.boxId) ? "编辑箱子" : "新增箱子";
    },
    materialColorLists() {
      const list = [];
      this.materials.forEach(material => {
        if (material.materialId == null || material.materialId === "") {
          return;
        }
        list.push({
          materialId: material.materialId,
          materialName: material.materialName,
          materialColor: material.materialId.toString(),
        });
        if (material.colorList && material.colorList.length > 0) {
          material.colorList.forEach(color => {
            list.push({
              materialId: material.materialId,
              materialName: material.materialName + "-" + this.getColorLabel(color),
              color: color,
              materialColor: material.materialId + "-" + color,
            });
          });
        } else if (material.colorType) {
          list.push({
            materialId: material.materialId,
            materialName: material.materialName + "-" + this.getColorLabel(material.colorType),
            materialColor: material.materialId + "-" + material.colorType,
          });
        }
      });
      return list;
    },
  },
  mounted() {
    this.getData();
    this.fetchMaterials();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    cmToInch(cm) {
      if (cm === "" || cm === null || cm === undefined || isNaN(Number(cm))) {
        return "--";
      }
      return parseFloat((Number(cm) / 2.54).toFixed(1));
    },
    formatSizeInch(row) {
      const lengthInch = row.lengthInch != null ? row.lengthInch : this.cmToInch(row.length);
      const widthInch = row.widthInch != null ? row.widthInch : this.cmToInch(row.width);
      const heightInch = row.heightInch != null ? row.heightInch : this.cmToInch(row.height);
      if (lengthInch === "--" || widthInch === "--" || heightInch === "--") {
        return "--";
      }
      return lengthInch + "*" + widthInch + "*" + heightInch;
    },
    getData() {
      this.loading = true;
      requestModules
        .fetchOutStockBoxs({})
        .then(res => {
          this.dataList = res.ldata || [];
          this.dataList.sort((a, b) => a.bubbleWeight - b.bubbleWeight);
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    addBox() {
      this.boxInfo = {
        width: "",
        height: "",
        length: "",
        remark: "",
        status: 1,
        inventory: 0,
      };
      this.addBoxDialogVisible = true;
    },
    editBox(row) {
      this.boxInfo = { ...row };
      this.addBoxDialogVisible = true;
    },
    handleConfirmBtn() {
      const outStockBox = { ...this.boxInfo };
      if (outStockBox.materialConfig != null && typeof outStockBox.materialConfig !== "string") {
        outStockBox.materialConfig = JSON.stringify(outStockBox.materialConfig);
      }
      this.saving = true;
      requestModules
        .addOrUpdateOutStockBox({ outStockBox })
        .then(() => {
          this.addBoxDialogVisible = false;
          this.getData();
        })
        .finally(() => {
          this.saving = false;
        });
    },
    fetchMaterials() {
      requestModules
        .fetchMaterials({ pageSize: 10000 })
        .then(res => {
          this.materials = res.ldata || [];
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: (err && (err.message || err.msg)) || "获取材料列表失败",
          });
        });
    },
    configMaterial(row) {
      this.materialBox = { ...row };
      this.materialConfig = this.parseMaterialConfig(row.materialConfig);
      this.configMaterialDialogVisible = true;
    },
    parseMaterialConfig(materialConfig) {
      if (!materialConfig) {
        return [{ materialColor: "", materialId: "", color: "", count: 1 }];
      }

      let list = materialConfig;
      if (typeof list === "string") {
        try {
          list = JSON.parse(list);
        } catch (error) {
          return [{ materialColor: "", materialId: "", color: "", count: 1 }];
        }
      }

      if (!Array.isArray(list) || list.length === 0) {
        return [{ materialColor: "", materialId: "", color: "", count: 1 }];
      }

      return list.map(config => {
        const item = {
          materialId: config.materialId || "",
          color: config.color || "",
          count: config.count || 1,
          materialColor: config.materialColor || "",
        };
        if (!item.materialColor && item.materialId) {
          item.materialColor = item.color ? item.materialId + "-" + item.color : String(item.materialId);
        }
        return item;
      });
    },
    buildMaterialConfigForSave(materialConfig) {
      return materialConfig.map(config => {
        const item = {
          materialId: config.materialId || "",
          color: config.color || "",
          materialColor: config.materialColor || "",
          count: Number(config.count) || 1,
        };
        if (config.materialColor) {
          const parts = String(config.materialColor).split("-");
          item.materialId = parts[0] || item.materialId;
          item.color = parts.length > 1 ? parts.slice(1).join("-") : "";
          item.materialColor = config.materialColor;
        }
        return item;
      });
    },
    addOneMaterial() {
      this.materialConfig.push({
        materialColor: "",
        materialId: "",
        color: "",
        count: 1,
      });
    },
    deleteMaterial(index) {
      this.materialConfig.splice(index, 1);
    },
    handleConfigMaterialConfirmBtn() {
      const normalizedConfig = this.buildMaterialConfigForSave(this.materialConfig);
      if (normalizedConfig.some(config => !config.materialId)) {
        this.$message({
          type: "error",
          message: "请完整选择材料",
        });
        return;
      }

      const outStockBox = { ...this.materialBox };
      outStockBox.materialConfig = JSON.stringify(normalizedConfig);
      this.materialSaving = true;
      requestModules
        .addOrUpdateOutStockBox({ outStockBox })
        .then(() => {
          this.configMaterialDialogVisible = false;
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.getData();
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: (err && (err.message || err.msg)) || "保存失败",
          });
        })
        .finally(() => {
          this.materialSaving = false;
        });
    },
    getMaterialConfigText(materialConfig) {
      if (!materialConfig) {
        return "";
      }

      let list = materialConfig;
      if (typeof list === "string") {
        try {
          list = JSON.parse(list);
        } catch (error) {
          return "";
        }
      }
      if (!Array.isArray(list)) {
        return "";
      }

      let txt = "";
      list.forEach((config, index) => {
        txt += "材料" + (index + 1) + "：" + this.getMaterialName(config.materialId);
        if (config.color) {
          txt += "-" + this.getColorLabel(config.color);
        }
        txt += "-" + config.count + "个；";
      });
      return txt;
    },
    getMaterialName(materialId) {
      const material = this.materials.find(item => item.materialId == materialId);
      return material ? material.materialName : "";
    },
    getColorLabel(colorType) {
      const color = this.colors.find(item => item.key == colorType);
      return color ? color.name : "";
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#OutStockBox.out-stock-box-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 1;
      font-size: 13px;
    }
  }

  .header-box {
    padding: 10px 16px;
    height: auto;

    .filter-toolbar {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 8px 12px;
      margin-top: 0;
    }

    .filter-actions {
      margin-top: 0;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }

    .toolbar-tip {
      color: #909399;
      font-size: 12px;
    }
  }

  .out-stock-box-table {
    .table-header-cell {
      padding: 8px 0;
      line-height: 1.45;
    }

    .cell {
      padding-left: 8px;
      padding-right: 8px;
      line-height: 20px;
    }

    .material-config-cell {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.out-stock-box-dialog {
  .form-line {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .form-label {
      flex-shrink: 0;
      width: 96px;
      margin-right: 12px;
      text-align: right;
      color: #606266;
      font-size: 13px;

      span {
        color: #f56c6c;
        margin-right: 2px;
      }
    }

    .form-input {
      width: 240px;
    }
  }

  .dialog-footer {
    text-align: right;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
}

.out-stock-box-material-dialog {
  .form-line {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .form-label {
      flex-shrink: 0;
      width: 72px;
      margin-right: 8px;
      text-align: right;
      color: #606266;
      font-size: 13px;

      span {
        color: #f56c6c;
        margin-right: 2px;
      }
    }

    .form-select {
      width: 240px;
      margin-right: 12px;
    }

    .count-label {
      margin-right: 8px;
      color: #606266;
      font-size: 13px;
    }

    .count-input {
      width: 100px;
      margin-right: 8px;
    }
  }

  .dialog-footer {
    text-align: right;
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
}
</style>
